// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2qnr-","approved":"Status_approved__1oenN","rejected":"Status_rejected__346N6","expired":"Status_expired__7mFQd","label":"Status_label__2Xuu_"};